const PHONE_SEARCH_FIELDS = new Set(["phone", "phone2", "emergencyContactNo"]);

const handleRegexSpecialChar = (text) => {
  const specialTxt = [
    "\\",
    "^",
    "$",
    ".",
    "|",
    "?",
    "*",
    "+",
    "(",
    ")",
    "[",
    "]",
    "{",
    "}",
  ];

  let result = text;
  specialTxt.forEach((special) => {
    result = result.replace(special, `\\${special}`);
  });
  return result;
};

const expandSearchField = (field) => {
  if (PHONE_SEARCH_FIELDS.has(field)) {
    return [`${field}.number`, `${field}.areaCode`, `${field}.countryCode`];
  }
  return [field];
};

export const buildSearchQuery = (searchText, searchFields) => {
  const txt = handleRegexSpecialChar(searchText)?.trim();
  if (!txt) return {};
  if (!searchFields?.length) return {};

  const searchArr = searchFields.flatMap((field) =>
    expandSearchField(field).map((expandedField) => ({
      [expandedField]: { $regex: txt, $options: "i" },
    })),
  );
  if (!searchArr.length) return {};
  return { $or: searchArr };
};
